import { createUseSafeLocationState } from '~/utils/SafeLocationState';

interface IShiftDetailsLocationState {
  preselectedDate: string;
  professionType: string;
}

export const useSafeShiftDetailsLocationState =
  createUseSafeLocationState<IShiftDetailsLocationState>({
    preselectedDate: '',
    professionType: '',
  });
